import Ingredient from '@/models/ingredient';
import { OrderProductIngredientProps } from '@/interfaces/models/orderPropductIngredient';
import NumberUtils from '@/utils/number.utils';
import numberUtils from "@/utils/number.utils";

export default class OrderProductIngredient {
  cost: number = 0;
  count: number = 1;
  discountAmount: number = 0;
  id: string = '';
  ingredient: Ingredient | null = null;
  unitCount: number = 1;

  public static createFromRequest(ingredientProps: OrderProductIngredientProps): OrderProductIngredient {
    const orderProductIngredient = new OrderProductIngredient();

    orderProductIngredient.cost = parseFloat(<any>ingredientProps.cost);
    orderProductIngredient.count = ingredientProps.count;
    orderProductIngredient.discountAmount = ingredientProps.discountAmount;
    orderProductIngredient.id = ingredientProps.id;
    orderProductIngredient.ingredient = Ingredient.createFromRequest(ingredientProps.ingredient);
    orderProductIngredient.unitCount = ingredientProps.unitCount;

    return orderProductIngredient;
  }

  public static createByOriginalIngredient(ingredient: Ingredient): OrderProductIngredient {
    const orderProductIngredient = new OrderProductIngredient();

    orderProductIngredient.ingredient = ingredient;
    orderProductIngredient.count = ingredient.count;
    orderProductIngredient.cost = ingredient.cost;
    orderProductIngredient.unitCount = ingredient.unitCount;

    return orderProductIngredient;
  }

  public get fullCount(): number {
    if (this.ingredient !== null) {
      return numberUtils.correctFloatNumber(this.count * this.ingredient.count);
    }

    return this.count;
  }

  public get fullCost(): number {
    return this.ingredient !== null
      ? numberUtils.correctFloatNumber(this.count * this.cost)
      : 0;
  }

  public get fullCostWithoutDiscount(): number {
    return this.ingredient !== null
      ? numberUtils.correctFloatNumber(this.count * (this.cost + this.discountAmount))
      : 0;
  }

  public get costWithoutDiscount(): number {
    return this.ingredient !== null
      ? NumberUtils.correctFloatNumber(this.cost + this.discountAmount)
      : 0;
  }

  public get hash(): string {
    if (null !== this.ingredient) {
      return `${this.ingredient.id}-${this.ingredient.count}-${this.ingredient.cost}`;
    }

    return '';
  }
}
